export default function BackToTopIcon() {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4835_497)">
        <path d="M8.79478e-08 29.9693C0.00125257 13.3928 13.4241 -0.00250461 30.0307 3.51269e-07C46.6624 0.00250531 60.01 13.4316 60.0013 30.1534C59.9925 46.6661 46.5058 60.0163 29.8466 60C13.3752 59.985 -0.00125239 46.5246 8.79478e-08 29.9693ZM29.9693 56.0008C44.3465 55.9307 55.9395 44.5031 55.9795 30.0607C56.0196 15.6873 44.5156 4.03674 30.0294 4.01921C15.6773 4.00167 4.05803 15.4831 4.0192 29.938C3.98038 44.3077 15.4769 55.8781 29.9693 56.0008Z" fill="grey"/>
        <path d="M30.052 26.4986C28.931 27.6346 27.9428 28.6454 26.9433 29.6461C24.2643 32.3264 21.5815 35.0017 18.8987 37.6782C18.3037 38.2719 17.5986 38.4924 16.7882 38.2293C16.0305 37.9839 15.5809 37.4353 15.4368 36.6587C15.2953 35.8947 15.6084 35.2923 16.142 34.76C19.6802 31.2317 23.211 27.696 26.7442 24.1627C27.3629 23.544 27.9741 22.919 28.6004 22.3091C29.5059 21.4273 30.5041 21.4148 31.4009 22.3091C35.5742 26.4686 39.7399 30.6356 43.9007 34.8076C44.8074 35.7169 44.835 36.9268 44.0046 37.7534C43.178 38.575 41.9681 38.5362 41.0588 37.6307C37.5481 34.1337 34.0424 30.6318 30.5405 27.1274C30.3789 26.9658 30.2574 26.7654 30.052 26.4986Z" fill="grey"/>
        </g>
        <defs>
        <clipPath id="clip0_4835_497">
        <rect width="60" height="60" fill="white"/>
        </clipPath>
        </defs>
        </svg>

    )
}

